module.exports = __webpack_public_path__ + "static/imbibe.3bdf2641.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/imbibe.jpg
// module id = 536
// module chunks = 70144966829960